<div class="confirm-payment-container d-flex flex-column gap-4">
  <button (click)="navigateHome()" class="btn btn-primary home-btn" type="button">
    <i class="fa-solid fa-house me-2"></i>Home
  </button>

  <div class="payment-container card p-4 d-flex flex-column gap-3">
    <h1 class="title">Judiciary Payment Portal Terms of Use</h1>

    <p>
      Thank you for visiting <strong>services.judiciary.gov.sg/epayments</strong>.  the official digital service of the Judiciary of Singapore and any applications or services related to or linked to or from this digital service ("Digital Service"). By accessing and using this Digital Service,
      you shall be deemed to have accepted and agreed to be legally bound by
      these Terms of Use,
      including any policies and guidelines incorporated by reference. If you do not accept or agree to any of these Terms of Use, you
      must
      discontinue your access and not use this Website or the Digital Service.
    </p>

    <div class="sub-title">General</div>
    <p>
      In these Terms of Use, the words "we", "our" and "us" refer to the Government of Singapore as represented by the
      Judiciary of Singapore.
    </p>
    <p>
      These Terms of Use may be changed from time to time without prior or further notice to you. Your use of this
      Digital Service after any amendments to these Terms of Use will constitute your agreement to the amended
      Terms of Use. </p>
    <div class="sub-title">Proprietary Rights</div>
    <p>
      This Digital Service is maintained by the Judiciary of Singapore.
    </p>
    <p>
      The materials located on this Digital Service including the information and software programs ("the Contents"), are
      protected by copyright, trademark and other forms of proprietary rights.All rights, title and interest in the
      Contents are owned by, licensed to or controlled by the Judiciary of Singapore.
    </p>

    <div class="sub-title">Privacy Policy</div>
    <p>
      Click <a (click)="onNavigateToPrivacy()">here</a> to review this Digital Service's Privacy Statement.
    </p>

    <div class="sub-title">Restrictions on Use of Materials</div>
    <p>
      Except as otherwise provided, the Contents of this Digital Service shall not be reproduced, republished, uploaded, posted,
      transmitted
      or otherwise distributed in any way, without the prior written permission of the Judiciary of Singapore.
    </p>
    <p>
      Modification of any of the Contents or use of the Contents for any other purpose will be a violation of our
      copyright and intellectual property rights.
    </p>

    <div class="sub-title">Payment Services</div>
    <p>
      This Digital Service enables users to make payments for court-related matters including court fines, fees, bail/bonds,
      Bailiffs/Sheriffs
      deposits, Service-In-Request fees, and Singapore International Commercial Court ("SICC") fees etc.
    </p>

    <p>
      You must provide accurate payment information as required, including Payment Reference numbers, Payer ID (as per NRIC/UEN/FIN/Passport/Foreign Identification record, where applicable), case
      numbers, and/or other reference numbers as applicable for different payment types. Failure to provide accurate
      information may result in unsuccessful or misdirected payments.
    </p>

    <p>Payment by Visa and MasterCard is subject to the following restrictions:</p>
    <ul style="margin-left: 20px;">
      <li>Maximum limit of $10,000 per Payment Advice/Invoice or scheduled Instalment payment for Court Fines.</li>
      <li>Maximum limit of $10,000 for deposits and other court-related payments.</li>
      <li>Not accepted for court bail/bond payments.</li>
    </ul>


    <p>
      All transactions shall be in Singapore dollars. Upon successful payment, an electronic receipt will be generated,
      which you should download and retain for your records, if required.
    </p>

    <p>
      We reserve the right to modify the payment methods, limits, and requirements at any time without prior notice.
    </p>

    <div class="sub-title">Communications</div>
    <p>We may communicate with you regarding your payment transactions or any related matters through:</p>
    <ul style="margin-left: 20px;">
      <li>Your provided email address; or</li>
      <li>Your provided Singapore Registered contact number.</li>
    </ul>


    <p>
      You must provide at least one valid contact method (either a contact number or email address) when making payments
      through this Digital Service. This information is necessary for payment-related communications.
    </p>

    <p>
      You are responsible for ensuring that the contact information you provide is accurate and current. We shall not be
      liable for any failure in communication arising from incorrect or outdated contact information.
    </p>

    <div class="sub-title">Links from this Digital Service to Other Websites</div>
    <p>
      This Digital Service may contain hyperlinks to websites which are not maintained by us. We are not responsible for the
      contents of those websites and shall not be liable for any damages or loss arising from access to those websites.
      Use of the hyperlinks and access to such websites are entirely at your own risk.
    </p>
    <p>
      Hyperlinks to other websites are provided as a convenience. In no circumstances shall we be considered to be
      associated or affiliated with any trade or service marks, logos, insignia or other devices used or appearing on
      websites to which this Website is linked.
    </p>

    <div class="sub-title">Links to this Digital Service from Other Websites</div>
    <p>
      Except as set forth below, caching and links to, and the framing of this Digital Service or any of the Contents are
      prohibited.
    </p>
    <p>
      You must secure permission from us prior to hyperlinking to, or framing, this Digital Service or any of the Contents, or
      engaging in similar activities. We reserve the right to impose conditions when permitting any hyperlinking to, or
      framing of this Website or any of the Contents.
    </p>

    <p>
      Your linking to, or framing any part of this Website or its Contents constitute acceptance of these Terms of Use, including any subsequent.
      Changes or modifications to these Terms of Use. If you
      do not accept these Terms of Use, you must discontinue linking to, or framing of this Digital Service or any of the
      Contents.
    </p>

    <p>
      In no circumstances shall we be considered to be associated or affiliated in whatever manner with any trade or
      service marks, logos, insignia or other devices used or appearing on websites that link to this Digital Service or any of
      the Contents.
    </p>

    <p>
      We reserve all rights to disable any links to, or frames of any site containing inappropriate, profane,
      defamatory, infringing, obscene, indecent or unlawful topics, names, material or information, or material or
      information that violates any written law, any applicable intellectual property, proprietary, privacy or publicity
      rights.
    </p>
    <p>
      We reserve the right to disable any unauthorised links or frames and disclaims any responsibility for the content
      available on any other site reached by links to or from this Digital Service or any of the Contents.
    </p>


    <div class="sub-title">Security</div>
    <p>
      Where appropriate, we use available technology to protect the security of communications made through this
      Digital Service. Notwithstanding the above, we do not accept liability for the security, authenticity, integrity or confidentiality of any
      transactions and other communications made through this Digital Service.
    </p>
    <p>
      Internet communications may be susceptible to interference or interception by third parties. Despite our best
      efforts, we make no warranties that this Digital Service is free of infection by computer viruses or other unauthorised
      software.
    </p>

    <div class="sub-title">Disclaimer of Warranties and Liability</div>
    <p>While every care is taken by us in providing the Contents and services on the Digital Service, we do not make any warranty or representation whatsoever and hereby disclaims all express, implied and statutory warranties of any kind to you, whether arising from usage or custom or trade or by operation of law or otherwise, including but not limited to the following: </p>
    <ul style="margin-left: 20px;">
      <li>That your use of, or access to the Digital Service will be uninterrupted, timely, secure, free of bugs, free from human tampering, free from viruses or other malicious, destructive or corrupting code, programme or macro, free from transmission errors or otherwise error-free or that there will not be any defects or deficiencies in the Digital Service;
      </li>
      <li>As regards the security of the Digital Service or the security of your information captured in or made available through payments made at the Digital Service; and
      </li>
      <li>As to the accuracy, completeness, reliability, non-infringement of third party rights, title, merchantability, satisfactory quality and/or fitness for any particular purpose of the Contents of the Digital Service.
      </li>
    </ul>
    <p>We shall not be liable for any damages, losses, compensation, penalty, expenses or costs whatsoever (whether direct, indirect, special or consequential damage or economic loss and whether foreseeable or not incurred on account of or arising from: </p>
    <ul style="margin-left: 20px;">
      <li>Using, visiting or relying on any statements, opinion, representation or information provided through the Digital Service; </li>
      <li>The access to the Digital Service or use of any services offered on the Digital Service; </li>
      <li>Any inaccuracy or incompleteness in or errors or omission in the content of the Digital Service;</li>
      <li>Any delay or errors in operation or transmission of the Digital Service arising from communications failure, internet access difficulties or malfunctions in equipment or software;</li>
      <li>Use or access to the Digital Service or any other website linked to the Digital Service or in connection with any failure of performance, error, omission, interruption, defect, delay in operation or transmission, computer virus or line or system failure; and </li>
      <li>Actions or omissions of any person who access or use the applications at the Digital Service or obtains any information obtained directly or indirectly through the Digital Service, regardless of whether we have been advised of the possibility of such damages, loss, compensation, penalty, expenses or costs. </li>
    </ul>


    <div class="sub-title">Right of Access</div>
    <p>The accessibility and operation of this Digital Service relies on technology outside of our control. We do not guarantee continuous accessibility or uninterrupted operation of this Digital Service. </p>
    <p>We reserve the right to temporarily suspend or shut down the Digital Service for system maintenance or for such other purpose as we may require, as and when necessary.</p>
    <p>
      We reserve all rights to deny or restrict access to this Digital Service to any particular person, or to block access from
      a particular Internet address to this Digital Service, at any time, without ascribing any reasons whatsoever.
    </p>

    <div class="sub-title">Governing Law</div>
    <p>
      These Terms of Use and all its subsequent variations shall be governed and construed in accordance with laws of the Republic of Singapore, and you hereby agree to submit to the exclusive jurisdiction of the Singapore courts in the determination of any dispute arising in connection with the use of the Digital Service.     </p>
  </div>
</div>
